import React, { FunctionComponent, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { HashLink } from "../../navigation/HashLink";
import { createHashStateHook } from "../../stores/useHashState";
import { Button } from "../../ui/Button/Button";
import { Drawer } from "../../ui/Drawer/Drawer";
import { FiltersIcon } from "../../ui/icons/FiltersIcon";

type FiltersSidebarProps = {
  children: ReactNode;
  className?: string;
};

const filtersHash = "#filters" as const;

export const useFiltersState = createHashStateHook(filtersHash);

export const FiltersSidebar: FunctionComponent<FiltersSidebarProps> = ({
  children,
  className,
}) => {
  const [visible, { hide }] = useFiltersState();
  const { t } = useTranslation();
  return (
    <>
      <HashLink hash={filtersHash}>
        <Button aria-label="openFiltersPanel" className={className} element="a">
          <FiltersIcon />
          {t("searchResults.filters")}
        </Button>
      </HashLink>
      <Drawer
        className="p-6 w-full max-w-[24em]"
        onClose={hide}
        placement="right"
        visible={visible}
      >
        {children}
      </Drawer>
    </>
  );
};
